function InternalNav() {
    const internalNav = document.querySelector('.c-internal-nav.u-sticky');

    if (!internalNav) {
        return;
    }

    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 1.0
    };

    const intersectionCallback = (entries, observer) => {
        const isIntersecting = entries[0].isIntersecting;
        internalNav.classList.toggle('c-internal-nav--stuck', !isIntersecting);
    };

    const observer = new IntersectionObserver(intersectionCallback, observerOptions);
    observer.observe(internalNav);
}

export default InternalNav;
